import { GetterTree } from 'vuex';
import { AttendeeModel } from '@descomplica/dex-models';
import { AttendeeState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<AttendeeState, RootState> = {
  attendeeById: (state, attendeeGetters) => (attendeeId: number) => {
    const attendeeArray = Object.values(state.attendeeList);
    const attendeePdo = attendeeArray.find((t) => t.id === attendeeId);

    const attendee = attendeePdo && new AttendeeModel(attendeePdo, attendeeGetters);

    return attendee;
  },
};

export default getters;
